import { get } from 'lodash-es'
import { toWorkflowData } from './toWorkflowData'

export const toApplicationData = (data: Json): TApplicationWorkflowData => {
    return {
        applicationObjectiveQAMap: get(data, 'applicationObjectiveQAMap'),
        languages: get(data, 'languages'),
        timelineEntries: get(data, 'timelineEntries'),
        workflow: toWorkflowData(data),
        workflowType: 'application',
        user: get(data, '_embedded.user'),
    }
}
